module.exports = __webpack_public_path__ + "media/images/icons/outlined/mac-command-899a3ca3fda492f5838f2d9b701edbbb.svg";